export const manifest = {
  screens: {
    scr_un6x1o: { name: "1 · Campaign overview", route: "/", state: {"currentIndex":0}, position: {"x":160,"y":220} },
    scr_lmjwnz: { name: "2 · Lead generation", route: "/", state: {"currentIndex":1}, position: {"x":1560,"y":220} },
    scr_eqsofk: { name: "3 · Brand engagement", route: "/", state: {"currentIndex":2}, position: {"x":2960,"y":220} },
    scr_d7mdst: { name: "4 · Market research", route: "/", state: {"currentIndex":3}, position: {"x":7160,"y":220} },
    scr_i3otm8: { name: "5 · Dual opportunity", route: "/", state: {"currentIndex":4}, position: {"x":8560,"y":220} },
    scr_apr2tv: { name: "6 · Viewer Response intelligence", route: "/", state: {"currentIndex":5}, position: {"x":15560,"y":220} },
    scr_bpp2ch: { name: "7 · Expansion", route: "/", state: {"currentIndex":6}, position: {"x":14160,"y":220} },
    scr_1hs3c9: { name: "8 · Success summary", route: "/", state: {"currentIndex":7}, position: {"x":2960,"y":2200} },
  },
  sections: {
    sec_ozog4i: { name: "Marketing analysis presentation", x: 0, y: 0, width: 32320, height: 1180 },
    sec_1evdfc: { name: "Campaign execution", x: 0, y: 1980, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ozog4i", children: [
      { kind: "screen", id: "scr_un6x1o" },
      { kind: "screen", id: "scr_lmjwnz" },
      { kind: "screen", id: "scr_eqsofk" },
      { kind: "screen", id: "scr_d7mdst" },
      { kind: "screen", id: "scr_i3otm8" },
      { kind: "screen", id: "scr_bpp2ch" },
      { kind: "screen", id: "scr_apr2tv" },
    ] },
    { kind: "section", id: "sec_1evdfc", children: [
      { kind: "screen", id: "scr_1hs3c9" },
    ] },
  ],
}
